import { getStartFollowUrl } from '@core/api'
import { httpClient } from '@core/http-client'

export const startFollow = (username: string) => {
    return httpClient.post(getStartFollowUrl(username))
}
